import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import Formatted from '@flipster/react/design-utils/formatted';
import { Styles } from '@flipster/styled-system/css';

import { HorizontalButtonGroup } from '../../misc/horizontal-button-group';
import { tpslModalInputBunja } from '../../state';

const percents = [-1, -0.1, +0.1, +1];

interface Props {
  css?: Styles;
}
export const LimitPriceRateButtons = ({ css: cssProps }: Props) => {
  const { buttonPropsArray } = useBunja(limitPriceRateButtonsBunja);
  return (
    <HorizontalButtonGroup css={cssProps}>
      {buttonPropsArray.map(({ percent, onClick }) => (
        <HorizontalButtonGroup.Button key={percent} onClick={onClick}>
          <Formatted.Percent value={percent} withPlus />
        </HorizontalButtonGroup.Button>
      ))}
    </HorizontalButtonGroup>
  );
};

const limitPriceRateButtonsBunja = bunja(() => {
  const { addLimitPercent } = bunja.use(tpslModalInputBunja);
  interface PercentAndOnClick {
    percent: number;
    onClick: () => void;
  }
  const buttonPropsArray: PercentAndOnClick[] = percents.map((percent) => ({
    percent,
    onClick: () => addLimitPercent(percent),
  }));
  return { buttonPropsArray };
});
limitPriceRateButtonsBunja.debugLabel = 'limitPriceRateButtonsBunja';
